import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ImmobilierService } from '../services/immobilier.service';
import { MaintenanceService } from '../services/maintenance.service';
import { ExpenseImmobilierService } from '../services/expense-immobilier.service';
import { Payment } from '../models/contract';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-dashboard-immobilier',
  templateUrl: './dashboard-immobilier.component.html',
  styleUrls: ['./dashboard-immobilier.component.css']
})
export class DashboardImmobilierComponent implements OnInit {

  // Statistiques générales
  stats: any = {};
  maintenanceStats: any = {};
  expenseStats: any = {};

  // Période
  dateRange = {
    start: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    end: new Date()
  };

  loading = false;

  // Paiements properties
  paymentsDataSource: MatTableDataSource<Payment>;
  paymentsDisplayedColumns: string[] = ['paymentDate', 'propertyName', 'clientName', 'amount', 'type', 'paymentMethod', 'status'];
  isPaymentsLoading = false;

  constructor(
    private immobilierService: ImmobilierService,
    private maintenanceService: MaintenanceService,
    private expenseService: ExpenseImmobilierService
  ) { }

  ngOnInit(): void {
    this.loadAllStatistics();
    this.loadAllPayments();
  }

  loadAllPayments(): void {
    this.isPaymentsLoading = true;
    this.immobilierService.getAllPayments().subscribe({
      next: (data) => {
        this.paymentsDataSource = new MatTableDataSource(data);
        this.isPaymentsLoading = false;
      },
      error: (err) => {
        console.error('Erreur lors du chargement des paiements', err);
        this.isPaymentsLoading = false;
      }
    });
  }

  applyPaymentsFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    if (this.paymentsDataSource) {
      this.paymentsDataSource.filter = filterValue.trim().toLowerCase();
    }
  }

  exportPaymentsToExcel(): void {
    if (!this.paymentsDataSource || this.paymentsDataSource.data.length === 0) {
      return;
    }
    const extract = this.paymentsDataSource.data.map(p => ({
      'Date': new Date(p.paymentDate).toLocaleDateString('fr-FR'),
      'Bien': p.propertyName || '',
      'Client': p.clientName || '',
      'Montant': p.amount,
      'Type': p.type,
      'Moyen': p.paymentMethod,
      'Statut': p.status,
      'Référence': p.reference || '',
      'Notes': p.notes || ''
    }));

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(extract);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Paiements');

    XLSX.writeFile(wb, 'historique_paiements.xlsx');
  }

  loadAllStatistics(): void {
    this.loading = true;

    // Charger les statistiques immobilières
    this.immobilierService.getStatistics().subscribe({
      next: (stats) => {
        this.stats = stats;
        this.loading = false;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des statistiques:', error);
        this.loading = false;
      }
    });

    // Charger les statistiques de maintenance
    this.maintenanceService.getStatistics().subscribe({
      next: (stats) => {
        this.maintenanceStats = stats;
      }
    });

    // Charger les statistiques de dépenses
    this.expenseService.getStatistics(this.dateRange.start, this.dateRange.end).subscribe({
      next: (stats) => {
        this.expenseStats = stats;
      }
    });
  }

  onDateRangeChange(): void {
    this.loadAllStatistics();
  }

  formatMoney(amount: number): string {
    if (!amount) return '0';
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'XOF',
      minimumFractionDigits: 0
    }).format(amount);
  }

  formatNumber(num: number): string {
    if (!num) return '0';
    return num.toString();
  }
}
